(function(){
  function mover(){
    var origem=document.querySelector('.hdt-product__title .hdt-product-form__btn-wishlist-wrapper');
    if(!origem||origem.getAttribute('data-jb-movido'))return;
    var alvo=document.querySelector('.hdt-product-form__top-buttons');
    if(!alvo)return;
    origem.setAttribute('data-jb-movido','1');
    origem.classList.add('jb-fav-pdp');
    origem.style.display='';
    alvo.appendChild(origem);
  }
  function iniciar(){mover();setTimeout(mover,600);setTimeout(mover,1800);}
  if(document.readyState!=='loading'){iniciar();}else{document.addEventListener('DOMContentLoaded',iniciar);}
  document.addEventListener('shopify:section:load',iniciar);
})();
